export const Footer = () => (
    <footer data-testid="footer" className="border-t border-vault-border bg-vault-black">
        <div className="mx-auto max-w-7xl px-6 py-16">
            <p className="font-display text-4xl uppercase leading-none text-stone-900 md:text-6xl">
                Vault<span className="text-vault-red">Deportivos</span>
            </p>
            <div className="mt-10 grid gap-8 border-t border-vault-border pt-10 font-mono text-xs tracking-[0.15em] text-stone-500 md:grid-cols-4">
                <div>
                    <p className="text-vault-red">STUDIO</p>
                    <p className="mt-3 leading-relaxed">Custom spray-painted sneakers. Masked, layered and sealed by hand. One of one, always.</p>
                </div>
                <div>
                    <p className="text-vault-red">PAYMENT</p>
                    <p className="mt-3 leading-relaxed">Pay by UPI / GPay scan or cash on delivery. Your call.</p>
                </div>
                <div>
                    <p className="text-vault-red">SHIPPING</p>
                    <p className="mt-3 leading-relaxed">Made to order. Ships in 5–7 days, tracked to your door.</p>
                </div>
                <div>
                    <p className="text-vault-red">POLICY & HELP</p>
                    <p className="mt-3 leading-relaxed">
                        No cancellations once an order is placed — every pair is painted for you. Returns accepted up
                        to 30 days. Need help? Mail us at vaultdeportivos@gmail.com
                    </p>
                </div>
            </div>
            <p className="mt-12 font-mono text-[10px] tracking-[0.3em] text-stone-400">
                © 2026 VAULT DEPORTIVOS — SPRAYED BY HAND, WORN LOUD
            </p>
        </div>
    </footer>
);
